// @avantia common-code
import { Policy } from '../types/policyTypes';
import { createMockPolicy } from './shared';

export const label = 'Buildings & Contents - FloodRe';

export const policy: Policy = createMockPolicy({
  policyNumber: 'B12/11000004',
  policyDetailsId: '110000041001',
  coverType: 'Buildings & Contents',
  isFloodRe: true
});
